import * as cn from "classnames";
import * as React from "react";
import "./LegendItem.css";

export interface LegendItemProps {
    checked: boolean;
    color: string;

    className?: string;
    children?: React.ReactChild | React.ReactChild[];

    onChange: () => void;
}

export function LegendItem(props: LegendItemProps) {
    const style = {
        backgroundColor: props.color,
        color: props.color
    };

    return (
        <div
            className={cn("legend-item", {
                active: props.checked
            })}
            onClick={props.onChange}
        >
            <div className="legend-item__color" style={style} />
            <div className="legend-item__text">{props.children}</div>
        </div>
    );
}
